<div class="iris-header-search"
  [class.expand]="isSearching">
  <form class="flex-valign">
    @if (isSearching) {
      <sk-select
        class="ng-select-header searching-types"
        data-test="header-searching-types"
        appendTo="body"
        [stylingMode]="'filled'"
        [noSubscriptBox]="true"
        [searchable]="false"
        [clearable]="false"
        [items]="availableSearchingTypes$ | async"
        [extraDense]="true"
        [ngModel]="selectedSearchingType"
        (ngModelChange)="onTypeChange($event)"
        [ngModelOptions]="{standalone: true}">
      </sk-select>
    }
    <div class="navbar-form dms radius">
      <div class="input-group"
        #searchDropdownTrigger="matMenuTrigger"
        [matMenuTriggerFor]="menu">
        <input type="text"
          #searchInput
          [formControl]="searchFormControl"
          (click)="onSearchClickEvent($event, searchDropdownTrigger.menuOpen)"
          autocomplete="off"
          class="form-control at-search-field"
          placeholder="{{'label.Search' | translate}}"
          data-test="header-search-input">
        <span class="input-group-btn">
          <sk-button class="search-button"
                     [appearance]="'icon'"
                     (click)="setFocused($event);"
                     type="button"
                     data-test="header-search-button">
            <span class="icon far fa-fw fa-search"></span>
          </sk-button>
          <sk-button class="clear-button"
                     [appearance]="'icon'"
                     [matTooltip]="'label.Clear' | translate"
                     (click)="clearSearchInput($event);"
                     type="reset"
                     data-test="header-search-clear-button">
            <span class="fa-fw icon" [ngClass]="{'icon-lg sk-icon sk-icon-times' : !isLoading , 'fas fa-spinner fa-spin': isLoading }"></span>
          </sk-button>
        </span>
      </div>
      <mat-menu class="iris-dropdown-menu header-search-overlay"
        #menu="matMenu"
        [hasBackdrop]="false"
        [class.while-loading-and-error]="isLoading || isSearchingError || searchStr.length < MIN_SEARCH_LEN">
        @if (searchStr.length >= MIN_SEARCH_LEN && !noSearchResults) {
          <ul class="items-container">
            @if (files.length) {
              <li class="header-group justify-content-between">
                @if (selectedSearchingType.name === 'all') {
                  <div>
                    <i class="fas fa-briefcase fa-fw"></i>&nbsp;{{ 'label.Files' | translate }}
                  </div>
                }
                <sk-button
                  [appearance]="'link'"
                  [color]="'primary'"
                  [size]="'sm'"
                  [label]="'label.ShowMore' | translate"
                  (click)="openUrl(getFilesShowMoreUrl())"
                  data-test="header-search-show-more-button">
                </sk-button>
              </li>
              <div>
                @for (file of files; track file) {
                  <li class="border-bottom">
                    <iris-header-search-result-card-template
                      (closeClick)="searchResultsClose()"
                      [titleData]="file.titleData"
                      [secondaryData]="file.secondaryData"
                      [cardLink]="file.cardLink">
                      <ng-template irisHeaderSearchResultCardPrimaryIcon>
                        <div class="item-left-sidebar">
                          <i class="icon-iris dms-icon-color"
                          [ngClass]="file.icon"></i>
                        </div>
                      </ng-template>
                    </iris-header-search-result-card-template>
                  </li>
                }
              </div>
            }
            @if (devices.length) {
              @if (selectedSearchingType.name === 'all') {
                <li
                  class="header-group">
                  <i class="fas fa-fw fa-train"></i>&nbsp;{{ 'label.Devices' | translate }}
                </li>
              }
              @for (device of devices; track device) {
                <li class="item">
                  <div class="item-content">
                    <div class="content-header">
                      <h4 class="title title-device-search flex-middle" (click)="goToDevice(device.id)" data-test="header-search-button-2">
                        <div class="led-status" [ngClass]="device.isActive? 'green' : 'red'"
                          [matTooltip]="(device.isActive? 'label.Active' : 'label.NotActive') | translate">
                        </div>
                        <a class="title-link" [href]="getDeviceUrl(device.id)" data-test="header-search-link">
                          {{device.name}} <i class="far fa-external-link"></i>
                        </a>
                      </h4>
                    </div>
                    <div class="content-body">
                      <p>{{ 'label.DeviceType' | translate }}: {{ device['deviceTypeName'] }}</p>
                      <p>{{ 'label.Company' | translate }}: {{ device['companyName'] }}</p>
                      <p>{{ 'label.MachineId' | translate }}: {{ device.machineId || '-' }}</p>
                    </div>
                  </div>
                </li>
              }
            }
            @if (projects.length) {
              <li class="header-group justify-content-between">
                @if (selectedSearchingType.name === 'all') {
                  <div>
                    <i class="fas fa-briefcase fa-fw"></i>&nbsp;{{ 'label.Projects' | translate }}
                  </div>
                }
                <sk-button
                  [appearance]="'link'"
                  [color]="'primary'"
                  [size]="'sm'"
                  [label]="'label.projects.ToProjectManagement' | translate"
                  (click)="openUrl(getProjectsShowMoreUrl(searchStr))"
                  data-test="header-search-to-project-management-button">
                </sk-button>
              </li>
              <div>
                @for (project of projects; track project) {
                  <li class="border-bottom">
                    <iris-header-search-result-card-template
                      (closeClick)="searchResultsClose()"
                      [titleData]="project.titleData"
                      [secondaryData]="project.secondaryData"
                      [cardLink]="project.cardLink">
                      <ng-template irisHeaderSearchResultCardPrimaryIcon>
                        <div class="text-medium">
                          <i class="fas fa-briefcase fa-3x text-disabled"></i>
                        </div>
                      </ng-template>
                    </iris-header-search-result-card-template>
                  </li>
                }
              </div>
            }
            @if (users.length) {
              @if (selectedSearchingType.name === 'all') {
                <li
                  class="header-group">
                  <i class="fas fa-users fa-fw"></i>&nbsp;{{ 'label.Users' | translate }}
                </li>
              }
              @for (user of users; track user) {
                <li class="item">
                  <iris-header-search-result-for-user [userInfo]="user">
                  </iris-header-search-result-for-user>
                </li>
              }
            }
          </ul>
        }
        @if (searchStr.length >= MIN_SEARCH_LEN && noSearchResults) {
          <ul class="items-container">
            <li class="header-group"> {{'label.NothingFound' | translate}}</li>
          </ul>
        }
      </mat-menu>
    </div>
  </form>
</div>
